<span>
    <a
        [attr.href]="url"
        [class.disabled]="!url"
        class="button is-primary"
        >Download</a
    >
</span>
